export const PENDING = '_PENDING'
export const FULFILLED = '_FULFILLED'
export const REJECTED = '_REJECTED'
export const FETCH = '_FETCH'
export const UPDATE = '_UPDATE'
export const CLEAR = '_CLEAR'
export const CREATE = '_CREATE'
export const TOGGLE = '_TOGGLE'
export const SET = '_SET'
